/* TRNR free shipping progress bar (2026-10-24). Keeps [data-trnr-fsb] bars in sync with the AJAX cart. No dependencies. */
(function () {
  if (window.__trnrFsb) return;
  window.__trnrFsb = true;

  function fmt(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    format = format || '${{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (key === 'amount_with_comma_separator') return amount.replace('.', ',');
      return withCommas;
    });
  }

  function render(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    var bars = document.querySelectorAll('[data-trnr-fsb]');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 19999;
      var remaining = threshold - cart.total_price;
      var pct = Math.max(0, Math.min(100, (cart.total_price / threshold) * 100));
      var text = bar.querySelector('[data-trnr-fsb-text]');
      var fill = bar.querySelector('[data-trnr-fsb-fill]');
      if (text) {
        text.innerHTML = remaining > 0
          ? "You're <strong>" + fmt(remaining, bar.getAttribute('data-money-format')) + '</strong> away from free shipping'
          : "You've unlocked free shipping";
      }
      if (fill) fill.style.width = pct + '%';
      bar.classList.toggle('is-unlocked', remaining <= 0);
      bar.classList.toggle('is-empty', cart.item_count === 0);
    }
  }

  var pending;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      _fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 150);
  }

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var _fetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch(input, init);
    if (CART_RE.test(url)) p.then(refresh, function () {});
    return p;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_RE.test(String(url))) this.addEventListener('loadend', refresh);
    return _open.apply(this, arguments);
  };

  document.addEventListener('flu:cart:updated', function (e) {
    if (e && e.detail && e.detail.cart) render(e.detail.cart); else refresh();
  });
  document.addEventListener('flu:quick-cart:open', refresh);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  window.trnrFreeShippingBarRefresh = refresh;
})();
